import type { AreaDict } from '../messages'

// Dashboard mensal e resumo de contas. pt-BR = textos atuais do app.
const dashboard: AreaDict = {
  'pt-BR': {
    'dash.title': 'Dashboard Mensal',
    'dash.subtitle': 'Visão do mês, consolidada em {currency}.',
    'dash.expectedBalance': 'Saldo previsto no fim do mês',
    'dash.breakdownAccounts': 'contas {value}',
    'dash.breakdownReceivable': ' + a receber {value}',
    'dash.breakdownDebts': ' − dívidas do mês {value} (inclui cartões)',
    'dash.breakdownRecurring': ' − recorrentes do mês {value}',
    'dash.incomeMonth': 'Receitas do mês',
    'dash.expenseMonth': 'Despesas do mês',
    'dash.resultMonth': 'Resultado do mês',
    'dash.received': '{value} recebido',
    'dash.paid': '{value} pago',
    'dash.accountsSummary': 'Resumo de contas',
    'dash.currencyNoRate': '* moeda sem taxa',
    'dash.emptyAccounts': 'Cadastre contas para ver o resumo.',
    'dash.partialSubtotal': '* subtotal parcial: alguma moeda sem taxa em cache.',
    'dash.typeCorrente': 'Corrente',
    'dash.typePoupanca': 'Poupança',
    'dash.typeCash': 'Cash',
    'dash.typeCarteira': 'Carteira',
    'dash.typeInvestimento': 'Investimentos',
    'dash.typeCartao': 'Cartões',
  },
  en: {
    'dash.title': 'Monthly Dashboard',
    'dash.subtitle': 'Month overview, consolidated in {currency}.',
    'dash.expectedBalance': 'Projected balance at month end',
    'dash.breakdownAccounts': 'accounts {value}',
    'dash.breakdownReceivable': ' + to receive {value}',
    'dash.breakdownDebts': ' − month debts {value} (includes cards)',
    'dash.breakdownRecurring': ' − month recurring {value}',
    'dash.incomeMonth': 'Income this month',
    'dash.expenseMonth': 'Expenses this month',
    'dash.resultMonth': 'Month result',
    'dash.received': '{value} received',
    'dash.paid': '{value} paid',
    'dash.accountsSummary': 'Accounts summary',
    'dash.currencyNoRate': '* currency without rate',
    'dash.emptyAccounts': 'Add accounts to see the summary.',
    'dash.partialSubtotal': '* partial subtotal: some currency has no cached rate.',
    'dash.typeCorrente': 'Checking',
    'dash.typePoupanca': 'Savings',
    'dash.typeCash': 'Cash',
    'dash.typeCarteira': 'Wallet',
    'dash.typeInvestimento': 'Investments',
    'dash.typeCartao': 'Cards',
  },
  es: {
    'dash.title': 'Panel Mensual',
    'dash.subtitle': 'Visión del mes, consolidada en {currency}.',
    'dash.expectedBalance': 'Saldo previsto a fin de mes',
    'dash.breakdownAccounts': 'cuentas {value}',
    'dash.breakdownReceivable': ' + por cobrar {value}',
    'dash.breakdownDebts': ' − deudas del mes {value} (incluye tarjetas)',
    'dash.breakdownRecurring': ' − recurrentes del mes {value}',
    'dash.incomeMonth': 'Ingresos del mes',
    'dash.expenseMonth': 'Gastos del mes',
    'dash.resultMonth': 'Resultado del mes',
    'dash.received': '{value} recibido',
    'dash.paid': '{value} pagado',
    'dash.accountsSummary': 'Resumen de cuentas',
    'dash.currencyNoRate': '* moneda sin tasa',
    'dash.emptyAccounts': 'Registra cuentas para ver el resumen.',
    'dash.partialSubtotal': '* subtotal parcial: alguna moneda sin tasa en caché.',
    'dash.typeCorrente': 'Corriente',
    'dash.typePoupanca': 'Ahorro',
    'dash.typeCash': 'Efectivo',
    'dash.typeCarteira': 'Cartera',
    'dash.typeInvestimento': 'Inversiones',
    'dash.typeCartao': 'Tarjetas',
  },
}

export default dashboard
